import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TheaterComedyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"theater_comedy"}/>
}
